export enum AccountBillingRateType {
    FLAT_RATE = 'FLAT_RATE',
    VARIABLE_SUBSCRIBER = 'VARIABLE_SUBSCRIBER',
    REVSHARE_PV = 'REVSHARE-PV',
}

// tslint:disable:no-namespace
export namespace AccountBillingRateType {
    export function fromString(str: string): AccountBillingRateType {
        switch (str.toUpperCase()) {
            case 'VARIABLE_SUBSCRIBER':
                return AccountBillingRateType.VARIABLE_SUBSCRIBER
            case 'REVSHARE_PV':
                return AccountBillingRateType.REVSHARE_PV
            case 'FLAT_RATE':
            default:
                return AccountBillingRateType.FLAT_RATE
        }
    }
}
